<template>
	<div class="content">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<!-- 关于我们 -->
		<div class="center flexbetween" :style="{animation:animation}">
			<div class="left">
				<div class="leftD" :style="{animation:animations}">
					<div class="leftD_child" v-for="item in aboutLists" @click="todetail(item.id)">{{item.name}}</div>
				</div>
			</div>
			<div class="right">
				<!-- <div class="header flexaround">
					<div :class="index==current?'childs':'child'" v-for="(item,index) in tabList" :key="index" @click="change(index)">{{item}}</div>
				</div> -->
				<div class="child" v-html="contents"> </div>
				<!-- <div class="child" v-for="(item,index)  in aboutList" :key="index">
					<div class="one flexbetween" style="align-items: flex-start;" v-if="index%2==0">
						<div class="txt" v-html="item.content"></div>
						<div class="img">
							<img :src="$index.addurl(item.image)" alt="">
						</div>
					</div>
					<div class="one flexbetween" style="align-items: flex-start;" v-else>
						<div class="img">
							<img :src="$index.addurl(item.image)" alt="">
						</div>
						<div class="txt" v-html="item.content"></div>
					</div>
				</div> -->
			</div>
			
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default{
		components: {
			headerTop
		},
		data(){
			return {
				tabList:[],
				aboutList:[],
				animation:'',
				animations:'',
				img:'',
				contents:'',
				current:0,
				data:{},
				aboutLists:[
					{
						name:'区位优势',
						id:8,
					},{
						name:'发展历程',
						id:9,
					},{
						name:'成果荣誉',
						id:10,
					},{
						name:'入驻机构',
						id:7,
					},
				],
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.animations = 'details .4s linear forwards'
			// this.getabout();
			this.getJg();
		},
		methods:{
			change(index){
				this.current  = index;
				this.contents = this.data[index].content;
			},
			getJg(){
				let id = this.$route.query.id;
				let _this = this;
				_this.$api.user.getSettledSetup({
				}).then(res => {
					if(res.code == 1){
						_this.contents = res.data.content;
						_this.img = res.data.background_img;
					}
				})
			},
			todetail(id){
				if(id == 7){
					this.$router.push({name:'aboutus'})
				}else if(id == 8){
					this.$router.push({name:'qwYoushi'})
				}else if(id == 9){
					this.$router.push({name:'fzLiucheng'})
				}else if(id == 10){
					this.$router.push({name:'cgRongyu'})
				}
			},
			getabout(){
				let _this = this;
				_this.$api.user.aboutusList().then(res => {
					if(res.code == 1){
						// _this.aboutList = res.data.list;
						// _this.img = res.data.background_img;
					}
				})
			},
		},
		
	}
</script>
<style scoped>
	.app-main-container{
		overflow: visible;
	}
	.content{
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
		/* overflow: hidden; */
	}
</style>
<style scoped lang="scss">
	.left{
		align-self: flex-start;
		position: sticky;
		top: 100px;
		padding-bottom: 30px;
		.leftD{
			background-color: #fff;
			border-radius: 20px;
			padding: 14px 30px 6px;
			width: 8vw;
			align-self: flex-start;
			z-index: 100;
			background-color: rgba(207, 232, 252, 0.5);
			margin-right: 30px;
			.leftD_child{
				margin: 20px 0;
				padding-bottom: 10px;
				font-size: 16px;
				text-align: center;
				color: #333;
				border-bottom: 1px solid #fff;
			}
			.leftD_child:last-child{
				border: none;
			}
			.leftD_child:hover{
				cursor: pointer;
				color: #1452DC;
				animation: changeTab .2s linear forwards;
			}
		}
	}
	.right{
		flex-grow: 1;
		align-self: flex-start;
		.header{
			border-radius: 10px;
			margin: 20px 0;
			background-color: rgba(207, 232, 252, 0.5);
			height: 60px;
			.child{
				flex-grow: 1;
				text-align: center;
				line-height: 60px;
				color: #333;
				cursor: pointer;
				font-size: 16px;
				border-radius: 10px;
			}
			.childs{
				flex-grow: 1;
				text-align: center;
				line-height: 60px;
				cursor: pointer;
				font-size: 16px;
				color: #fff;
				background-color: #1452DC;
				border-radius: 10px;
			}
			.child:hover{
				cursor: pointer;
				animation: changeTabs .2s linear forwards;
			}
		}
	}
	.swiperImg{
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 220px 0;
		.lTitle{
			margin-left: 4vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}
		.bTitle{
			margin-left: 4vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 4px;
			font-weight: bold;
		}
		.sTitle{
			margin-left: 4vw;
			letter-spacing: 2px;
			font-size: 14px;
			color: #fff;
		}
	}
	.center{
		min-height: 300px;
		margin: 0 14vw 100px;
		background-color: #fff;
		padding: 80px 120px 60px 60px;
		border-radius: 30px;
		position: relative;
		top: -80px;
		overflow: visible;
		.page{
			margin: auto;
			display: flex;
			justify-content: center;
		}
		.child{
			// margin-bottom: 30px;
			.img{
				width: 45%;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.txt{
				align-items: flex-start;
				width: 45%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// aboutus.vue?16eff308